let NavList = [
  {
    text: "Home",
    Icon: "HomeIcon",
    children: [{ Name: "Home", Path: "Staff", NewTab: false }],
  },
  {
    text: "Agents",
    Icon: "RememberMeIcon",
    children: [
      { Name: "View Agencies", Path: "Staff/ViewAgencies", NewTab: false },
      { Name: "View EC's", Path: "Staff/ViewECs", NewTab: false },
            { Name: "EndOfYearStaffView", Path: "Staff/EndOfYearStaffView", NewTab: false },

      
    ],
  },
  {
    text: "Schools",
    Icon: "SchoolIcon",
    children: [
      { Name: "View Schools", Path: "Staff/ViewSchools", NewTab: false },
      {
        Name: "Add Schools",
        Path: "Staff/ViewSchool/AddSchool",
        NewTab: false,
      },
      {
        Name: "View Events Old",
        Path: "Staff/ViewSchoolEventsOld",
        NewTab: false,
      },
    ],
  },
  {
    text: "Registers",
    Icon: "ChecklistIcon",
    children: [
      { Name: "Registers", Path: "Staff/ViewRegisters", NewTab: false },
      { Name: "Live Numbers", Path: "Staff/LiveTable", NewTab: false },
      {
        Name: "Public Reg Form",
        Path: "Public/RegistrationForm/Anonymous",
        NewTab: true,
      },
      {
        Name: "SEF Homepage",
        Path: "Staff/SEFRegisters",
        NewTab: true,
      },
      {
        Name: "Arrival/Departures",
        Path: "Staff/ArrivalDepartureHome",
        NewTab: false,
      },
    ],
  },
  {
    text: "Shopify",
    Icon: "ShoppingCartIcon",
    children: [
      { Name: "Shopify Orders", Path: "Staff/ViewOrders", NewTab: false },
    ],
  },
  {
    text: "Xero",
    Icon: "ReceiptLongIcon",
    children: [
      { Name: "View Invoices", Path: "Staff/ViewInvoices", NewTab: false },
      {
        Name: "Add Invoice",
        Path: "Staff/ViewInvoice/AddInvoice",
        NewTab: false,
      },
      {
        Name: "View Transactions",
        Path: "Staff/ViewTransactions",
        NewTab: false,
      },
      {
        Name: "Add Transaction",
        Path: "Staff/ViewTransaction/AddTransaction",
        NewTab: false,
      },
      {
        Name: "Import Transactions",
        Path: "Staff/ImportTransactions",
        NewTab: false,
      },
    ],
  },
  {
    text: "Zoom",
    Icon: "DuoIcon",
    children: [
      { Name: "View Webinar", Path: "Staff/ViewWebinar", NewTab: false },
    ],
  },
  {
    text: "Power BI",
    Icon: "AutoGraphIcon",
    children: [
      {
        Name: "Registers",
        Path: "Staff/PowerBI/Registers",
        NewTab: false,
      },
      {
        Name: "Master Sales",
        Path: "Staff/PowerBI/MasterSales",
        NewTab: false,
      },
      {
        Name: "Invoices",
        Path: "Staff/PowerBI/Invoices",
        NewTab: false,
      },
      {
        Name: "STX",
        Path: "Staff/PowerBI/STX",
        NewTab: false,
      },
      {
        Name: "Logs",
        Path: "Staff/PowerBI/Logs",
        NewTab: false,
      },
      { Name: "Schools", Path: "Staff/PowerBI/Schools", NewTab: false },
      {
        Name: "Partnerships",
        Path: "Staff/PowerBI/Partnerships",
        NewTab: false,
      },
    ],
  },
  {
    text: "Misc",
    Icon: "MiscellaneousServicesIcon",
    children: [
      {
        Name: "Attendees & Schools",
        Path: "Staff/AssignAttendeeToSchool",
        NewTab: false,
      },
      {
        Name: "SXP Attendees & Schools",
        Path: "Staff/AssignSXPAttendeeToSchool",
        NewTab: false,
      },
      {
        Name: "Schools & Countries",
        Path: "Staff/AssignSchoolToCountry",
        NewTab: false,
      },
    ],
  },
  {
    text: "Emails",
    Icon: "EmailIcon",
    children: [
      {
        Name: "Summer Letters",
        Path: "Staff/SummerLetters",
        NewTab: false,
      },
      {
        Name: "GSP Booking Emails",
        Path: "Staff/GSPBookingEmails",
        NewTab: false,
      },
      {
        Name: "TCS Certificates",
        Path: "Staff/TCSCertificates",
        NewTab: false,
      },
      {
        Name: "Import TCS Certificates",
        Path: "Staff/ImportTCSCertificates",
        NewTab: false,
      },

      {
        Name: "STX/Admin - Invoice Reminders",
        Path: "Staff/InvoiceReminders",
        NewTab: false,
      },
      {
        Name: "Admin - WEF Emails",
        Path: "Staff/ViewPortalEmails",
        NewTab: false,
      },
      {
        Name: "STX/Admin - SEF Emails",
        Path: "Staff/SEFEmails",
        NewTab: false,
      },
      {
        Name: "STX/Admin - Arrival Departure Emails",
        Path: "Staff/ArrivalDepartureEmails",
        NewTab: false,
      },
      {
        Name: "Admin - Arrival Departure Confirmation Emails",
        Path: "Staff/ArrivalDepartureConfirmationEmails",
        NewTab: false,
      },
      {
        Name: "Admin - SXP Pre Programme",
        Path: "Staff/SXPPreProgramme",
        NewTab: false,
      },
      
      {
        Name: "Admin - SXP REACH",
        Path: "Staff/SXPREACHEmail",
        NewTab: false,
      },
      {
        Name: "Admin - SXP REACH To Parents",
        Path: "Staff/SXPREACHEmailToParents",
        NewTab: false,
      },
      {
        Name: "Admin - SXP Post Programme",
        Path: "Staff/SXPPostProgramme",
        NewTab: false,
      },
    ],
  },
  {
    text: "CurtAI",
    Icon: "PsychologyIcon",
    children: [
      { Name: "CurtAI", Path: "Staff/CurtAI", NewTab: false },
      {
        Name: "Medical",
        Path: "Staff/CurtAI_Get_Medical_Overview",
        NewTab: false,
      },
    ],
  },
  {
    text: "Settings",
    Icon: "SettingsIcon",
    children: [
      {
        Name: "Programmes List",
        Path: "Staff/ProgrammeList",
        NewTab: false,
      },
      {
        Name: "Pre/Post SXP Programme Data",
        Path: "Staff/PreSXPProgrammeData",
        NewTab: false,
      },
      {
        Name: "REACH Parent Details",
        Path: "Staff/REACHParentDetails",
        NewTab: false,
      },
      {
        Name: "StaffTestPage",
        Path: "Staff/StaffTestPage",
        NewTab: false,
      },
      ,
    ],
  },
  {
    text: "Reach",
    Icon: "SettingsIcon",
    children: [
      {
        Name: "Post",
        Path: "Staff/Reach_Part1_Post",
        NewTab: false,
      },
      {
        Name: "MedicalSync",
        Path: "Staff/Reach_Part2_MedicalSync",
        NewTab: false,
      },
      {
        Name: "MedicalGeneral",
        Path: "Staff/REACH_Part3_MedicalGeneral",
        NewTab: false,
      },
      {
        Name: "User Defined Fields",
        Path: "Staff/REACH_Part4_UserDefinedFields",
        NewTab: false,
      },
      {
        Name: "Post Associations",
        Path: "Staff/REACH_Part5_PostAssociations",
        NewTab: false,
      },
      {
        Name: "Put Associations",
        Path: "Staff/REACH_Part6_PutAssociations",
        NewTab: false,
      },
      {
        Name: "Put Parents Associations",
        Path: "Staff/REACH_Part6_PutAssociationsParents",
        NewTab: false,
      },
      {
        Name: "Sync Photos",
        Path: "Staff/REACH_Part7_SyncPhotos",
        NewTab: false,
      },
      {
        Name: "Accom Update",
        Path: "Staff/REACH_Part8_AccomTypeUpdate",
        NewTab: false,
      },
    ],
  },
];

export default NavList;
